export default __webpack_public_path__ + "c1848a7b0f808b67a371a1112974cc5d.png";